<template>
	<v-card class="elevation-0 attendees-page attendees-page-container page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<FilterChipButton
				:isButtonActive="isButtonActive"
				:chipsList="chipsList"
				:clearFilter="clearFilter"
				@handleChipClick="handleChipClick"
			/>

			<div v-if="filterModalIsVisible">
				<FilterModal
					:filterModalIsVisible="filterModalIsVisible"
					:currentModalFilter="currentModalFilter"
					:currentModalLabel="currentModalLabel"
					:selectedChips="selectedChips"
					:filters="filters"
					:dateError="date.error"
					:dateOption="date.option"
					:dateRange="date.selectedRange"
					@closeModal="closeModal"
					@applySelection="applySelection"
					@setItem="setItem"
				/>
			</div>
			<div class="d-flex">
				<v-skeleton-loader
					v-if="isLoading"
					v-bind="attrs"
					class="mt-3"
					max-width="555"
					width="100%"
					type="list-item, list-item-three-line, card-heading"
				>
				</v-skeleton-loader>

				<div v-else style="width: 100%">
					<div v-for="(attend, index) in attendees" :key="index">
						<router-link
							:to="{
								name: isCurrentUser(attend.user_id) ? 'profile' : 'user-by-id',
								params: isCurrentUser(attend.user_id) ? [] : { id: attend.user_id },
							}"
							class="text-decoration-none"
						>
							<AttendCard :user="attend" :event="event" />
						</router-link>
					</div>
					<div
						class="d-flex my-9 justify-center home-page__pagination"
						v-if="!isLoading && attendees.length > 0"
					>
						<Pagination
							:page="filters.page"
							:pageCount="+this.pageCountAttendees"
							v-on:pageChange="onPageChange"
						/>
					</div>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AttendCard from '@/components/Event/AttendCard'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'

import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'
import Filter from '@/mixins/Filter'
import FilterModal from '@/components/Modals/FilterModal.vue'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import UserPreview from '@/components/User/UserPreview.vue'

export default {
	name: 'AttendeesPage',
	mixins: [Block, Dwh, Filter],
	components: {
		UserPreview,
		NewsFeedEmpty,
		FilterChipButton,
		FilterModal,
		AttendCard,
		Pagination,
		PageBlocked,
	},
	methods: {
		...mapActions('event', ['getAttendeesEvent']),
		...mapActions('app', ['setPageTitle']),
		isCurrentUser(userId) {
			if (!this.profile) {
				return false
			}

			const { user_id: currentUserId } = this.profile
			return userId === currentUserId
		},
	},

	created() {
		if (this.eventSettings && this.eventSettings.show_attendees) {
			if (this.$route.params.id !== undefined) {
				this.getAttendeesEvent(this.requestQuery)
			}
		} else {
			this.$router.push('/')
		}
		this.sendTrigger({
			category: 'Content',
			action: 'view_attendees_list_event',
			module: 'Events',
			data: this.$route.params.id,
			content_chapter_id:
				this.event && this.event.chapter_id ? [this.event.chapter_id] : null,
		})
	},

	computed: {
		...mapGetters('event', ['isLoading', 'pageCountAttendees', 'attendees', 'event']),
		...mapGetters('settings', ['eventSettings']),
		...mapGetters('auth', ['profile']),
	},
	mounted() {
		this.setPageTitle('Attendees')
	},
	beforeDestroy() {
		this.setPageTitle('')
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
			},
			pageBlockedName: 'events',
		}
	},
}
</script>

<style lang="scss">
.attendees-page {
	background: #f1f1f1 !important;
	max-width: 555px;
	width: 100%;
}
</style>
